/**
 * StatusBadge — pill-style status indicator with dot.
 * Props:
 *   status {string} — 'open' | 'inprogress' | 'waiting_for_customer' | 'closed'
 *   size   {string} — 'sm' | 'default'
 */

import { h } from 'preact'

export const STATUS_LABELS = {
  open:                 'Nyitva',
  inprogress:           'Folyamatban',
  waiting_for_customer: 'Ügyfélre vár',
  closed:               'Lezárt',
}

// Returns the CSS modifier suffix matching status-select-btn class names
export function statusCssKey(status) {
  return status || 'open'
}

export function StatusBadge({ status, size = 'default' }) {
  const label = STATUS_LABELS[status] || status || 'Ismeretlen'
  const key   = statusCssKey(status)

  return (
    <span class={`status-select-btn status-${key}${size === 'sm' ? ' status-sm' : ''}`}>
      <span class={`status-dot status-dot-${key}`} />
      {label}
    </span>
  )
}
